// src/pages/List.js
export default function List() {
  return <div>Це List</div>;
}